// ── 매입 관리 [📤 업로드 ▾] (2026-11-03 사용자 "업로드 버튼을 만들고 그 안에 넣자") ──────────────
// 누르면 세 가지: 📤 엑셀/CSV 업로드(바로 파일 고르기) · 📋 붙여넣기 추가(붙여넣기 창) · 🕘 이력보기(업로드 이력 창).
// 차단형 모달 아님(드롭다운) — 스크롤 잠금 없이 투명 클릭아웃으로 닫는다(직원 관리·출퇴근 ☰ 메뉴와 같은 방식).
import React, { useRef, useState } from 'react';
import { stdBlackBtn } from '../adminlayout/designStandard';

export default function UploadMenu({ onUpload, onOpenPaste, onOpenHistory }) {
  const fileRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [uploading, setUploading] = useState(false);

  async function handleFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    await onUpload(file);
    setUploading(false);
    if (fileRef.current) fileRef.current.value = '';
  }

  const items = [
    { key: 'file', label: '📤 엑셀/CSV 업로드', onClick: () => fileRef.current?.click() },
    { key: 'paste', label: '📋 붙여넣기 추가', onClick: onOpenPaste },
    { key: 'history', label: '🕘 이력보기', onClick: onOpenHistory },
  ];

  return (
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        style={{ ...stdBlackBtn, opacity: uploading ? 0.6 : 1 }}
        disabled={uploading}
        onClick={() => setOpen((v) => !v)}
      >
        {uploading ? '업로드 중...' : '📤 업로드 ▾'}
      </button>
      <input ref={fileRef} type="file" accept=".xlsx,.xls,.csv" style={{ display: 'none' }} onChange={handleFile} />
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 900 }} onClick={() => setOpen(false)} />
          <div role="menu" style={menuStyle}>
            {items.map((it) => (
              <button
                key={it.key}
                type="button"
                role="menuitem"
                style={itemStyle}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--bg-subtle)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                onClick={() => { setOpen(false); it.onClick?.(); }}
              >
                {it.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

const menuStyle = {
  position: 'absolute', top: 'calc(100% + 6px)', right: 0, zIndex: 901, minWidth: 190, padding: 6,
  background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12,
  boxShadow: '0 12px 32px rgba(15,27,53,0.14)',
};
const itemStyle = {
  display: 'block', width: '100%', textAlign: 'left', padding: '10px 14px', minHeight: 40, borderRadius: 8,
  border: 0, background: 'transparent', color: 'var(--text)', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
};
